import { render, staticRenderFns } from "./OrganismVamosPaLaCalleUploadEvidence.vue?vue&type=template&id=16c0df8c&scoped=true"
import script from "./OrganismVamosPaLaCalleUploadEvidence.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismVamosPaLaCalleUploadEvidence.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0df8c",
  null
  
)

export default component.exports